module.exports = __webpack_public_path__ + "img/pic39.c3e8e7e3.png";